export default __webpack_public_path__ + "static/media/quiz-pic-3.ade0712f.jpeg";